import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

// actions
import { fetchRegistrations } from 'ducks/merchantDucks/audience/actions';

// selectors
import {
  getTotalRegistrations,
  getRegistrationMethod,
  getRegistrationDevices,
} from 'ducks/merchantDucks/audience/selectors';

// components
import { SubscriptionsContainer } from '../Subscriptions/SubscribersSection';
import RegistrationMethod from './RegistrationMethod';
import AuthenticationDevice, { DeviceType } from './AuthenticationDevice';

const RegistrationsContainer = styled(SubscriptionsContainer)`
  margin-bottom: 1rem;
`;

const RegistrationsSection: React.FC = () => {
  const dispatch = useDispatch();
  const registrationMethod = useSelector(getRegistrationMethod);
  const registrationDevices = useSelector(getRegistrationDevices);
  const totalRegistrations = useSelector(getTotalRegistrations);

  useEffect(() => {
    dispatch(fetchRegistrations());
  }, [fetchRegistrations]);
  return (
    <RegistrationsContainer>
      <AuthenticationDevice
        deviceType={DeviceType.REGISTRATION}
        authDevices={registrationDevices}
        totalAuthData={totalRegistrations}
      />
      <RegistrationMethod registrationMethod={registrationMethod} />
    </RegistrationsContainer>
  );
};

export default RegistrationsSection;
